import React, { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import withConfig from '../../wrappers/withConfig'
import 'jspdf-autotable'
import Spinner from '../../elem/Spinner'
import BackButton from '../../elem/BackButton'
import PageNotFound from '../../PageNotFound'
import { Helmet } from 'react-helmet'
import JobOverview from './JobOverview'
import DisclosureOverview from './DisclosureOverview'
import IngredientTable from './IngredientTable'

const DisclosureDetailComponent = ({ config }) => {
    const { id } = useParams()
    const [data, setData] = useState(null)
    const [overviewData, setOverviewData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState(null)
    const [hasError, setHasError] = useState(false)
    const { API_URL } = config

    const fetchData = useCallback(async (searchURL) => {
        await axios
            .get(searchURL)
            .then((res) => {
                const responseData = res.data
                if (responseData) {
                    const { Wells } = responseData
                    if (Wells && Wells.length > 0) {
                        setData(Wells)
                        const wellData = Wells[0]
                        setOverviewData(wellData)
                    } else {
                        throw new Error('No matching well')
                    }
                } else {
                    throw Error('No matching well')
                }
            })
            .catch((error) => {
                setOverviewData(null)
                setData(null)
                setHasError(true)
                setErrorMessage('Failed to fetch the data.')
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        const searchURL = `${API_URL}/FracFocus/WellByApiNumber?api14=${id}`
        fetchData(searchURL)
    }, [fetchData])

    return (
        <div className="container_page">
            <Helmet>
                <title>Disclosure</title>
                <link rel="icon" href="/favicon.ico" />
            </Helmet>
            <div>
                <BackButton
                    label={`< BACK TO SEARCH`}
                    extraClass={'back_to_search'}
                />
            </div>
            {/* Conditionally Rendering *********************** */}
            {overviewData && (
                <div className="page">
                    <DisclosureOverview overviewData={overviewData} loading={loading} />
                    {data.map((wellData) => (
                        <>
                            <JobOverview data={wellData} />
                            <IngredientTable data={wellData} />
                        </>
                    ))}

                    <div id="fineprint">
                        <p className="closing">
                            Total Water Volume sources may include various types
                            of water including fresh water, produced water, and
                            recycled water. Information is based on the maximum
                            potential for concentration and thus the total may
                            be over 100%.
                        </p>
                        <div></div>
                    </div>
                    {errorMessage ? (
                        <div className="errorMessage">{errorMessage}</div>
                    ) : null}
                </div>
            )}
            {!data && !hasError && <Spinner />}
            {hasError && <PageNotFound />}
        </div>
    )
}

const DisclosureDetail = withConfig(DisclosureDetailComponent)

export default DisclosureDetail
